const modules = import.meta.glob('../../components/AldooAgent/actions/*.js', { eager: true })

const actions = {}

for (const path in modules) {
  const mod = modules[path]
  const action = mod.default
  if (!action || !action.id) continue
  actions[action.id] = action
}

function getCapabilities() {
  return Object.values(actions).map(a => ({
    id:          a.id,
    description: a.description,
    parameters:  a.parameters || { type: 'object', properties: {} }
  }))
}

function has(id) {
  return id in actions
}

async function execute(id, params = {}) {
  const action = actions[id]
  if (!action) throw new Error(`Unknown action: ${id}`)
  return action.handler(params)
}

export default { getCapabilities, has, execute }
